export default "__VITE_ASSET__Ymt1GJCs__"